export function JobillaLogo() {
	return (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" height="48" width="48">
				<path
					fill="#fff"
					d="M42.654 16.347v-.002a4.115 4.115 0 0 0-.811-2.44 3.892 3.892 0 0 0-3.132-1.638l-.08-.002H9.335c-2.23 0-4.04 1.847-4.04 4.125v21.53c.012.946.317 1.777.812 2.44a3.894 3.894 0 0 0 3.131 1.638l.079.002h29.3c2.23 0 4.038-1.846 4.038-4.125V16.347Z"
				/>
				<path fill="#304FFB" d="M25.461 2.695h-2.923v6.878h2.923V2.695Z" />
				<path
					fill="url(#a)"
					d="M31.418 9.572H16.583c-1.48 0-2.68 1.222-2.68 2.73s1.2 2.73 2.68 2.73h14.835c1.48 0 2.679-1.222 2.679-2.73s-1.2-2.73-2.68-2.73Z"
				/>
				<path
					fill="url(#b)"
					d="M5.295 37.906V16.394c0-2.281 1.811-4.13 4.045-4.13h29.318c3.93 0 5.55 5.144 2.36 7.486L11.7 41.26c-2.676 1.964-6.404.01-6.404-3.354l-.001-.001Z"
				/>
				<path
					fill="url(#c)"
					d="M42.71 16.402v21.511c0 2.282-1.81 4.13-4.044 4.13H9.347c-3.929 0-5.55-5.143-2.36-7.485l29.319-21.51c2.675-1.964 6.404-.01 6.404 3.354Z"
					opacity=".82"
				/>
				<path fill="url(#d)" d="M36.297 42.044h-8.965v5.1c0 .697.758 1.102 1.3.692l7.665-5.792Z" />
				<path
					fill="url(#e)"
					d="M24 7.444c2.017 0 3.653-1.666 3.653-3.722S26.017 0 24 0c-2.018 0-3.654 1.666-3.654 3.722S21.982 7.444 24 7.444Z"
				/>
				<path
					fill="#0BB5E4"
					d="M31.694 36.462c5.059 0 9.16-4.178 9.16-9.332 0-5.154-4.101-9.331-9.16-9.331-5.058 0-9.159 4.177-9.159 9.331s4.1 9.332 9.16 9.332Z"
				/>
				<path
					fill="#fff"
					d="M31.695 33.595c3.441 0 6.231-2.85 6.231-6.366 0-3.516-2.79-6.366-6.232-6.366-3.441 0-6.231 2.85-6.231 6.366 0 3.516 2.79 6.366 6.232 6.366Z"
				/>
				<path
					fill="url(#f)"
					d="M31.694 30.71c1.887 0 3.416-1.559 3.416-3.48 0-1.923-1.53-3.48-3.416-3.48s-3.415 1.557-3.415 3.48c0 1.921 1.529 3.48 3.415 3.48Z"
				/>
				<path
					fill="#0BB5E4"
					d="M43.81 22.961h-3.968a9.338 9.338 0 0 1 1.026 4.27c0 1.54-.372 2.99-1.026 4.268h3.968c2.305 0 4.19-1.921 4.19-4.269s-1.885-4.269-4.19-4.269Z"
				/>
				<path
					fill="#39D0FD"
					d="M43.79 31.498c2.312 0 4.203-1.92 4.203-4.269 0-2.348-1.89-4.268-4.202-4.268h-1.083v8.537h1.083Z"
				/>
				<path
					fill="#6ADCFD"
					d="M40.867 27.23c0-1.54-.372-2.99-1.026-4.27h-3.524a6.42 6.42 0 0 1 1.608 4.27 6.412 6.412 0 0 1-1.609 4.268h3.524a9.34 9.34 0 0 0 1.026-4.269h.001Z"
				/>
				<path
					fill="#0BB5E4"
					d="M16.305 36.485c5.058 0 9.159-4.178 9.159-9.331 0-5.154-4.1-9.332-9.16-9.332-5.058 0-9.159 4.178-9.159 9.332 0 5.153 4.101 9.331 9.16 9.331Z"
				/>
				<path
					fill="#fff"
					d="M16.304 33.52c3.442 0 6.232-2.85 6.232-6.366 0-3.516-2.79-6.366-6.232-6.366-3.441 0-6.231 2.85-6.231 6.366 0 3.516 2.79 6.366 6.231 6.366Z"
				/>
				<path
					fill="url(#g)"
					d="M16.305 30.634c1.886 0 3.415-1.558 3.415-3.48s-1.529-3.48-3.415-3.48c-1.887 0-3.416 1.558-3.416 3.48s1.53 3.48 3.416 3.48Z"
				/>
				<path
					fill="#0BB5E4"
					d="M4.19 22.886h3.968a9.339 9.339 0 0 0-1.026 4.268c0 1.54.372 2.991 1.026 4.269H4.19c-2.305 0-4.19-1.92-4.19-4.269 0-2.348 1.885-4.268 4.19-4.268Z"
				/>
				<path
					fill="#39D0FD"
					d="M4.21 31.423c-2.312 0-4.203-1.92-4.203-4.268s1.89-4.27 4.202-4.27h1.083v8.538H4.209Z"
				/>
				<path
					fill="#6ADCFD"
					d="M7.133 27.154c0-1.54.371-2.99 1.026-4.269h3.524a6.42 6.42 0 0 0-1.608 4.269 6.41 6.41 0 0 0 1.609 4.268H8.16a9.339 9.339 0 0 1-1.027-4.268Z"
				/>
				<defs>
					<linearGradient
						id="a"
						x1="13.904"
						x2="34.097"
						y1="12.302"
						y2="12.302"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#304FFB" />
						<stop offset="1" stopColor="#39D0FD" />
					</linearGradient>
					<linearGradient
						id="b"
						x1="5.295"
						x2="42.711"
						y1="27.154"
						y2="27.154"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#710DE0" />
						<stop offset="1" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient id="c" x1="0" x2="42.711" y1="27.154" y2="27.154" gradientUnits="userSpaceOnUse">
						<stop stopColor="#710DE0" />
						<stop offset="1" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient
						id="d"
						x1="28.315"
						x2="33.066"
						y1="48.221"
						y2="40.144"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#710DE0" />
						<stop offset="1" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient id="e" x1="21.416" x2="26.68" y1="6.355" y2="1.188" gradientUnits="userSpaceOnUse">
						<stop stopColor="#710DE0" />
						<stop offset="1" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient
						id="f"
						x1="28.279"
						x2="35.111"
						y1="27.229"
						y2="27.229"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#304FFB" />
						<stop offset="1" stopColor="#1028AE" />
					</linearGradient>
					<linearGradient
						id="g"
						x1="19.721"
						x2="12.889"
						y1="27.154"
						y2="27.154"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#304FFB" />
						<stop offset="1" stopColor="#1028AE" />
					</linearGradient>
				</defs>
			</svg>
		</>
	)
}
